const NoData = () => {
  return <div className="nocontent">No content to display.</div>;
};

export default NoData;
